import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { BaseUrlConstantsService } from "../../../../app/services/base-url-constants.service";
import { EnergyMeterService } from "../../../../app/services/energymeter.service";
import { CommonModule } from "@angular/common";
import { DialogOverviewExampleDialogComponent } from "../../../dialog-overview-example-dialog/dialog-overview-example-dialog.component";
import { MeterServiceModalComponent } from "../meter-service-modal/meter-service-modal.component";
import { MatTooltip } from "@angular/material/tooltip";

@Component({
  selector: "app-meter-service",
  templateUrl: "./meter-service.component.html",
  styleUrls: ["./meter-service.component.scss"],
  standalone: true,
  imports: [CommonModule,MeterServiceModalComponent,MatTooltip]
})
export class MeterServiceComponent implements OnInit, OnDestroy {
  public emeterData = BaseUrlConstantsService.energyMeterApi;

  public meterData: {
    client_id: string;
    generic_asset_id: number;
    subsystem_id: string;
  };
  public meterDataSub = new Subscription();
  public serviceData: any;
  public serviceLoader = true;
  public serviceDataErr = false;
  public isOutForService = false;
  public showGreasingModal = false;
  public showOFSModal = false;
  public outOfServiceChange = false;

  constructor(private service: EnergyMeterService) {}

  ngOnInit(): void {
    this.meterDataSub = this.service.meterDataObs.subscribe((data) => {
      localStorage.setItem('generic_asset_id', data.generic_asset_id);
      console.log(data,'---------------------------------------');
      this.meterData = data;
      data.ofs == "0"
        ? (this.isOutForService = false)
        : (this.isOutForService = true);
      console.log(data)
      if (data.subsystem_id) {
        this.fetchServiceRecordData();
      }
    });
  }
  ngOnDestroy(): void {
    this.meterDataSub.unsubscribe();
  }

  // ---------------------------------- GREASING MODAL LOGIC --------------------

  updateGreasingService() {
    this.showGreasingModal = true;
  }

  saveGreasingService(data) {
    this.showGreasingModal = false;
    this.fetchServiceRecordData();
  }
  closeGreasingService(isChange: boolean=false) {
    this.showGreasingModal = false;
    isChange && this.fetchServiceRecordData()
  }

  // ------------------------------------- SERVICE MODAL LOGIC --------------------------------

  fetchServiceRecordData() {
    this.serviceLoader = true;
    this.serviceDataErr = false;
    this.service
      .fetchServiceRecordData(
        // `${this.emeterData}/service-record?id=${this.meterData.subsystem_id}`
        `${this.emeterData}/greasing-record?id=${this.meterData.subsystem_id}&client_id=${this.meterData.client_id}&generic_asset_id=${this.meterData.generic_asset_id}`

        // `http://localhost:3105/emeter/service-record?id=${this.meterData.subsystem_id}`
      )
      .then((data: any) => {
        this.serviceData = data;
        this.service.setMeterServiceData({...data,ofs:this.isOutForService});
      })
      .catch(() => {
        this.serviceData = {
          last_greasing_date: "N/A",
          next_greasing_date: "N/A",
          total_hrs_till_now: "N/A",
          act_total_hrs_till_now: "N/A",
          act_nxt_greasing_date: "N/A",
          service_id: "N/A",
        };
        this.serviceDataErr = true;
      }).finally(()=>{
        this.serviceLoader = false;
      })
  }

  onOFTToggleChange(event: any) {
    const isChecked = (event.target as HTMLInputElement).checked;
    console.log(event)
    // console.log(
    //   event.source.checked,
    //   this.isOutForService,
    //   this.outOfServiceChange
    // );
    event.target.checked = this.isOutForService;

    this.outOfServiceChange = !this.isOutForService;
    this.showOFSModal = true;
  }
  // onOFTToggleChange(event: any) {
  //   console.log(event)
  //   // console.log(
  //   //   event.source.checked,
  //   //   this.isOutForService,
  //   //   this.outOfServiceChange
  //   // );
  //   event.source.checked = this.isOutForService;

  //   this.outOfServiceChange = !this.isOutForService;
  //   this.showOFSModal = true;
  // }

  closeOFSModal(data: any) {
    /*
        - If we changed the toggle new state true/false is saved which open the modal but if cancelled the revert the this.outOfServiceChange variable
        - Only works when toggle was changed to true or false for OUT FOR SERVIE CHANGE not greasing change
    */
    // if(data?.changed==false){
    //   this.outOfServiceChange=!this.outOfServiceChange
    // }
    this.showOFSModal = false;
  }

  saveOFSModalData() {
    this.showOFSModal = false;
    this.isOutForService = this.outOfServiceChange;
    this.fetchServiceRecordData();
  }
}
